import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { EMPTY_OBJECT, errorMessages } from '../../constants/globalConstants'
import { QRCodeSVG } from 'qrcode.react'
import moment from 'moment'
import NoImage from './NoImage'
import { globalKeyStore } from '../../redux/actions/globalState'
import { isTimeBeforeCurrentFacilityTime } from '../../utils/helper'

function EventCard({
    imageUrl, title, detials, startDate, time, paybaleAmount, id, handleBookingButtton, key, className,
    isMainScreen, parkingPrice, selectEventType, sessionDetails, displayQr, hidePaymentDetails,
    paymentResponse, qrCodeValue, isCrousalEvent, facilitiesName, eventViewStyle, facilityPrice,
    isBookingClosed: isBookingClosedProp, dispatch, notify, selectedEvent }) {


    // Local state to manage Sold Out button (for main screen)
    const [localIsBookingClosed, setLocalIsBookingClosed] = useState(isBookingClosedProp)

    // Keep in sync if prop changes from parent
    useEffect(() => {
        setLocalIsBookingClosed(isBookingClosedProp)
    }, [isBookingClosedProp])


    const handleBooking = (id) => {
        localStorage?.setItem('selectEventType', 'event')
        localStorage?.setItem('booking_event', id)
        dispatch(globalKeyStore({ selectedEventId: id }))
        let end_time = selectedEvent?.end_time
        if (end_time) {
            localStorage.setItem('end_time', end_time)
        }

        let facilityTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
        let isBookingClosedCheck = isTimeBeforeCurrentFacilityTime(selectedEvent?.stop_event_booking_time, facilityTimeZone)

        if (isBookingClosedCheck) {
            // Set internal state so Sold Out button appears immediately
            setLocalIsBookingClosed(true)
            notify('error', errorMessages?.soldOutError)
        } else {
            handleBookingButtton()
        }
    }

    return (
        <div className={(className) ? className : 'col'} key={key}>
            <div className="card h-100">
                <div className="row g-0 h-100">
                    <div className='col-md-4 border-end'>
                        {/* <div className='w-100 h-100' style={{ backgroundImage: 'url(' + imageUrl + ')', backgroundSize: '150px', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', minHeight: '200px' }}> */}
                        <div className='w-100 h-100 text-center d-flex justify-content-center align-items-center'>
                            <span>
                                {imageUrl === 'NoImage' ? <NoImage /> : <img src={imageUrl} className='img-fluid custom-card-img' width='100%' />}
                            </span>
                        </div>
                    </div>
                    <div className={displayQr ? 'col-md-6' : 'col-md-8'}>
                        <div className="card-body">
                            {paymentResponse?.ticketech_code ? <p className='mb-2 fw-bold'>Booking ID - {paymentResponse?.ticketech_code}</p> : ''}
                            <h4 className="card-title fw-bold text-primary">{title}</h4>
                            {detials != '' && <p className="card-text mb-1" dangerouslySetInnerHTML={{ __html: detials }} />}
                            <p className="fw-bold"><i className="fa fa-map-marker"></i> {facilitiesName}</p>
                            <div className={(eventViewStyle == 'list') ? 'd-sm-flex border rounded text-dark' : 'border rounded text-dark'}>
                                <h5 className="fw-bold m-0 border-end p-2 w-100"><i className="fa fa-calendar me-2"></i> {moment(startDate)?.format('dddd Do MMM, YYYY')} </h5>
                                <div className='w-100 border-bottom d-block d-sm-none'></div>
                                <h5 className="m-0 p-2 w-100"><b className="fw-bold me-2">Event Start At - </b><i className="fa fa-clock me-2"></i> {moment(startDate).format('hh:mm A')} </h5>
                            </div>
                            <p>{`*Event parking starts at ${time?.startDate} & ends at  ${time?.endDate}`}</p>

                            {isMainScreen ?
                                <div className="d-flex justify-content-between">
                                    <div className="h2 fw-bold text-dark m-0">$ {Number(paybaleAmount) > 0 || (Number(facilityPrice) === 0 && Number(paybaleAmount) === 0) ? paybaleAmount : facilityPrice}{/* <small className="fw-light" style={{ fontSize: '1rem' }}>+ tax</small>*/}</div>
                                    <button type='button' className={`btn btn-${localIsBookingClosed ? 'secondary' : 'primary'}`} disabled={localIsBookingClosed} onClick={() => localIsBookingClosed ? null : handleBooking(id)}>{localIsBookingClosed ? 'Sold Out' : 'Book Parking'}</button>
                                </div> :
                                hidePaymentDetails ? null : <div className="bill-card">
                                    {parkingPrice !== undefined && <div className="row mb-1 align-items-center">
                                        <div className="col text-start">Parking Price{/* Including Tax*/}</div>
                                        <div className="col text-end">{`$${Number(parkingPrice) > 0 || (Number(parkingPrice) === 0 && Number(facilityPrice) === 0) ? parkingPrice : facilityPrice}`}</div>
                                    </div>}
                                    {Number(sessionDetails?.data?.tax_rate) > 0 ?
                                        <div className="row align-items-center">
                                            <div className="col text-start">Processing Fee</div>
                                            <div className="col text-end">{`$${Number(sessionDetails?.data?.tax_rate)?.toFixed(2)}`}</div>
                                        </div> : ''}
                                    {Number(sessionDetails?.data?.processing_fee) > 0 ?
                                        <div className="row align-items-center">
                                            <div className="col text-start">Processing Fee</div>
                                            <div className="col text-end">{`$${Number(sessionDetails?.data?.processing_fee)?.toFixed(2)}`}</div>
                                        </div> : ''}
                                    {sessionDetails?.data?.discounted_amount || sessionDetails?.data?.discounted_amount > 0 ? <div className="row mb-3 align-items-center">
                                        <div className="col text-start">Discount Amount</div>
                                        <div className="col text-end">{`$${(sessionDetails?.data?.discounted_amount)?.toFixed(2)}`}</div>
                                    </div> : ''}
                                </div>}
                        </div>
                        {((selectEventType == 'event' && !isMainScreen && !isCrousalEvent) || (!isCrousalEvent && paymentResponse?.total)) && <div className="card-footer p-3 bg-info bg-opacity-10">
                            <div className="row">
                                <div className="col text-start">
                                    <p className="lead fw-bold m-0">Total</p>
                                </div>
                                <div className="col text-end">
                                    <p className="lead m-0 fw-bold">{`$${sessionDetails?.data?.amount || sessionDetails?.data?.amount == 0 ? Number(sessionDetails?.data?.amount)?.toFixed(2) : Number(paymentResponse?.total)?.toFixed(2)}`}</p>
                                </div>
                            </div>
                        </div>}
                    </div>
                    {displayQr ? <div className="col-sm-2 text-center bg-light border-start p-3">
                        {(paymentResponse?.mapco_qrcode?.length > 0) && (qrCodeValue) && (
                            <QRCodeSVG
                                value={qrCodeValue}
                                width="100%"
                                height="70%"
                            // size={180}
                            />
                        )}
                        <h4 className="fw-bold mt-3 mb-0">{qrCodeValue}</h4>
                    </div> : null}
                </div>
            </div>
        </div>
    )
}

EventCard.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    detials: PropTypes.string,
    startDate: PropTypes.string,
    time: PropTypes.object,
    paybaleAmount: PropTypes.string,
    id: PropTypes.number,
    handleBookingButtton: PropTypes.func,
    key: PropTypes.number,
    className: PropTypes.string,
    isMainScreen: PropTypes.bool,
    bookingFormPage: PropTypes.number,
    parkingPrice: PropTypes.string,
    tax_rate: PropTypes.string,
    amount: PropTypes.string,
    selectEventType: PropTypes.string,
    sessionDetails: PropTypes.object,
    displayQr: PropTypes.bool,
    hidePaymentDetails: PropTypes.bool,
    paymentResponse: PropTypes.object,
    qrCodeValue: PropTypes.string,
    isCrousalEvent: PropTypes.bool,
    eventViewStyle: PropTypes.string,
    facilitiesName: PropTypes.string,
    facilityPrice: PropTypes.string,
    isBookingClosed: PropTypes.bool,
    selectedEvent: PropTypes.object,
}

EventCard.defaulProps = {
    dispatch: noop,
    imageUrl: '',
    notify: noop,
    title: '',
    detials: '',
    startDate: '',
    time: '',
    paybaleAmount: '',
    id: '',
    handleBookingButtton: noop,
    key: 0,
    className: '',
    isMainScreen: false,
    bookingFormPage: 0,
    parkingPrice: 0,
    tax_rate: 0,
    amount: 0,
    selectEventType: '',
    sessionDetails: EMPTY_OBJECT,
    displayQr: false,
    hidePaymentDetails: false,
    paymentResponse: EMPTY_OBJECT,
    qrCodeValue: '',
    isCrousalEvent: false,
    eventViewStyle: '',
    facilitiesName: '',
    facilityPrice: '',
    isBookingClosed: false,
    selectedEvent: EMPTY_OBJECT,
}


function mapStateToProps({ globalReducers }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        eventData: globalReducers?.eventData,
        noOfEventShow: globalReducers?.noOfEventShow,
        bookingFormPage: globalReducers?.bookingFormPage,
        selectEventType: globalReducers?.selectEventType,
        sessionDetails: globalReducers?.sessionDetails,
        eventViewStyle: globalReducers?.eventViewStyle,
    }
}

export default connect(mapStateToProps)(EventCard)